import { Apis } from "libs/apis";


export const usePrintRetailersById = () => {
  const getPrintViewByOrderId = async (orderId: string, setData: Function) => {
    await Apis.getPrintViewByOrderId(orderId)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };


  return { getPrintViewByOrderId };
};
